import { render, staticRenderFns } from "./DashMovimenti.vue?vue&type=template&id=8c25c952&scoped=true"
import script from "./DashMovimenti.vue?vue&type=script&lang=js"
export * from "./DashMovimenti.vue?vue&type=script&lang=js"
import style0 from "./DashMovimenti.vue?vue&type=style&index=0&id=8c25c952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c25c952",
  null
  
)

export default component.exports